/**
 * Environment Configuration
 *
 * IMPORTANT: React only exposes environment variables that start with REACT_APP_ to the frontend JavaScript.
 * This is a security feature to prevent accidentally exposing sensitive data in the browser.
 *
 * - Variables with SECRET_ prefix are NOT accessible to frontend code
 * - Only REACT_APP_ prefixed variables are included in the client bundle
 * - For secrets needed in frontend, create REACT_APP_ versions in the build script
 */

export const MILES_SERVER_V2_URL = process.env.REACT_APP_MILES_SERVER_V2_URL

// Using REACT_APP_ prefixed variables (these are created from the SECRET_ versions in the GitHub workflow)
export const ANCHOR_PROVIDER_URL = process.env.REACT_APP_ANCHOR_PROVIDER_URL || '[Error: URL not found]'
export const ANCHOR_PROVIDER_URL_FALLBACK =
    process.env.REACT_APP_ANCHOR_PROVIDER_URL_FALLBACK || '[Error: URL not found]'

export const V1_API_URL_TESTNET = process.env.REACT_APP_V1_API_URL_TESTNET

// V2 API URL for migration
export const V2_API_URL = process.env.REACT_APP_V2_API_URL

// Feather API URL
export const FEATHER_API_URL = process.env.REACT_APP_FEATHER_API_URL

// Get the testnet deployment flag
const IS_TESTNET_DEPLOYMENT = process.env.REACT_APP_IS_TESTNET_DEPLOYMENT === 'true'

// Use testnet pricing API when IS_TESTNET_DEPLOYMENT is true
export const MACHPROTOCOL_API_URL = IS_TESTNET_DEPLOYMENT
    ? process.env.REACT_APP_PRICE_API_URL_TESTNET
    : process.env.REACT_APP_PRICE_API_URL

// Use testnet URLs when IS_TESTNET_DEPLOYMENT is true
export const V1_API_URL = IS_TESTNET_DEPLOYMENT
    ? process.env.REACT_APP_V1_API_URL_TESTNET
    : process.env.REACT_APP_V1_API_URL
